var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStarOutlined(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_20_238)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.8188 6.8407C16.6795 6.41148 16.2972 6.107 15.8477 6.06727L11.6719 5.70727L10.035 1.81477C9.86074 1.39712 9.45254 1.12514 9 1.12514C8.54746 1.12514 8.13926 1.39712 7.965 1.81477L6.33305 5.70727L2.15227 6.06938C1.70091 6.1073 1.31632 6.41222 1.17645 6.84303C1.03658 7.27384 1.16872 7.74652 1.51172 8.04234L4.68352 10.8141L3.73289 14.9302C3.63012 15.3705 3.80102 15.8296 4.16672 16.0956C4.53241 16.3616 5.02183 16.3828 5.40914 16.1494L8.99508 13.9697L12.5887 16.1494C12.9761 16.3828 13.4655 16.3616 13.8312 16.0956C14.1969 15.8296 14.3678 15.3705 14.265 14.9302L13.3151 10.8098L16.4862 8.04234C16.8292 7.74548 16.9603 7.27167 16.8188 6.8407ZM15.7486 7.19227L12.5775 9.95977C12.263 10.2334 12.1255 10.6584 12.2203 11.0644L13.173 15.1875L9.58219 13.0078C9.22504 12.7903 8.77637 12.7903 8.41922 13.0078L4.83328 15.1875L5.77969 11.0672C5.87447 10.6612 5.73702 10.2362 5.4225 9.96258L2.25 7.19648C2.24974 7.19438 2.24974 7.19226 2.25 7.19016L6.42938 6.82875C6.84523 6.7921 7.20659 6.52818 7.36805 6.1432L9 2.25563L10.6313 6.1432C10.7927 6.52818 11.1541 6.7921 11.5699 6.82875L15.75 7.19016C15.75 7.19016 15.75 7.19437 15.75 7.19508L15.7486 7.19227Z",
    fill: "#F5C754"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_20_238"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarOutlined);
export default __webpack_public_path__ + "static/media/star-outlined.fcc36e87eefa0ab9f1b510c17d24657d.svg";
export { ForwardRef as ReactComponent };